import React from 'react';
import { FadeIn } from './FadeIn';
export function ProofSection() {
  return <section className="bg-brand-navy text-white py-24 px-6" data-id="element-172">
      <div className="max-w-4xl mx-auto" data-id="element-173">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-174">
          <FadeIn data-id="element-175">
            <div className="bg-white/10 p-8 rounded-3xl backdrop-blur-sm border border-white/20" data-id="element-176">
              <div className="text-5xl font-bold text-brand-teal mb-4" data-id="element-177">10+</div>
              <p className="text-xl leading-relaxed text-gray-200" data-id="element-178">
                Within 7 days of using this method, most teens can identify at
                least 10 businesses in their own zip code that are actively
                losing customers simply because they haven't posted in a month.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-179">
            <div className="bg-white/10 p-8 rounded-3xl backdrop-blur-sm border border-white/20" data-id="element-180">
              <div className="text-5xl font-bold text-brand-teal mb-4" data-id="element-181">
                $250/mo
              </div>
              <p className="text-xl leading-relaxed text-gray-200" data-id="element-182">
                By closing just two of these gaps at $250/month, your teen is
                out-earning almost every "summer job" in town while working a
                fraction of the hours.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}